import type { FeatureConfigData, FeatureConfigInfo } from '@change-corgi/core/fcm';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

export function createFcmGetter<T extends Record<string, FeatureConfigInfo>>(
	configs: T,
): (utilityContext: UtilityContext) => Promise<FeatureConfigData<T>> {
	return async (utilityContext: UtilityContext) => utilityContext.fcm.get(configs);
}
